/**
 * Check if focus is within an element or its descendants.
 */
export const hasFocusWithin = ($element: JQuery): boolean => {
    const activeElement = document.activeElement;
    if (!activeElement) {
        return false;
    }
    return $element[0]?.contains(activeElement) ?? false;
};
